import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";
import {
  ClientTag,
  CreateClientTagPayload,
  UpdateClientTagPayload,
} from "../types/clientTag";
import { Client } from "./clientService";

const api = new APIClient();

const RESOURCE = "/client-tags";

export interface ClientTagListParams extends PaginationParams {
  search?: string;
  is_active?: boolean;
}

export const getClientTags = (
  params?: ClientTagListParams
): Promise<PaginatedApiResponse<ClientTag>> =>
  api.get<PaginatedApiResponse<ClientTag>>(RESOURCE, params);

export const getClientTag = (
  id: number
): Promise<ApiResponse<ClientTag>> =>
  api.get<ApiResponse<ClientTag>>(`${RESOURCE}/${id}`);

export const createClientTag = (
  payload: CreateClientTagPayload
): Promise<ApiResponse<ClientTag>> =>
  api.create<ApiResponse<ClientTag>>(RESOURCE, payload);

export const updateClientTag = (
  id: number,
  payload: UpdateClientTagPayload
): Promise<ApiResponse<ClientTag>> =>
  api.update<ApiResponse<ClientTag>>(`${RESOURCE}/${id}`, payload);

export const deactivateClientTag = (
  id: number
): Promise<ApiResponse<ClientTag>> =>
  api.delete<ApiResponse<ClientTag>>(`${RESOURCE}/${id}`);

export const syncClientTags = (
  clientId: number,
  tagIds: number[]
): Promise<ApiResponse<Client>> =>
  api.put<ApiResponse<Client>>(`/clients/${clientId}/tags`, { tag_ids: tagIds });
